import ActionTypes from "../../../constants/ActionTypes";
import { IRemoveUserMessageAction, ISetUserMessageAction } from "./types";

export const setUserLabelMessage = (
  label: string,
  entity: string
): ISetUserMessageAction => ({
  type: `${entity} ${ActionTypes.USER_MESSAGE.SET}`,
  payload: { label, entity },
});


export const removeUserLabelMessage = (): IRemoveUserMessageAction => ({
  type: `${ActionTypes.USER_MESSAGE.SET}`,
  payload: {
    label: "",
    entity: ""
  },
});
